<template>
  <div class="c-carouselbox__container">
    <img :src="image" alt="" class="c-carouselbox__image" />
    <h1 class="c-carouselbox__title">{{ title }}</h1>
    <div class="c-carouselbox__points" v-if="cost">
      <span class="c-carouselbox__points__text">{{ cost }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    cost: {
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.c-carouselbox__container {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  background-color: white;
  height: 100%;
  min-width: 250px;
  @include md {
    padding: 4rem 1rem;
    margin: 1rem;
  }
}

.c-carouselbox__image {
  padding: 2rem 1rem;
  width: 100%;
  max-height: 350px;
  @include md {
    padding: 0;
  }
}

.c-carouselbox__title {
  padding: 2rem 0 2rem 0;
  font-size: 18px;
  @include md {
    padding: 2rem 0 0 0;
    font-size: 30px;
  }
}

.c-carouselbox__points {
  position: absolute;
  bottom: -20px;
  left: calc(50% - 90px);
  font-size: 1.3rem;
  font-weight: 600;
  background-color: #6221e6;
  color: white;
  border-radius: 27.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 40px;
  padding: 0 1rem;
  @include md {
    left: calc(50% - 100px);
    width: 200px;
    height: 55px;
  }
}

.c-carouselbox__points__text {
  font-size: 18px;
}
</style>
